// extracted by mini-css-extract-plugin
export var fadeIn = "_8c-0";